import {
  FACILITY_STORINGEN_LOADING,
  FACILITY_STORINGEN_SUCCESS,
  FACILITY_STORINGEN_ERROR,
  FACILITY_STORING_DETAIL_SUCCESS,
  FACILITY_STORING_CREATE_SUCCESS,
  FACILITY_STORING_UPDATE_SUCCESS,
  FACILITY_ACCOMMODATIES_SUCCESS,
  FACILITY_ACCOMMODATIE_DETAIL_SUCCESS,
  FACILITY_WERKORDERS_SUCCESS,
  FACILITY_WERKORDER_DETAIL_SUCCESS,
  FACILITY_CATEGORIES_SUCCESS,
  FACILITY_EXISTING_ACCOMMODATIES_SUCCESS,
  FACILITY_EXISTING_KAMPEERPLAATSEN_SUCCESS,
  FACILITY_DASHBOARD_SUCCESS
} from './actions';

const initialState = {
  storingen: {
    results: [],
    totalPages: 0,
    currentPage: 1,
    total: 0,
    loading: false,
    error: null
  },
  storingDetail: null,
  accommodaties: {
    results: [],
    totalPages: 0,
    currentPage: 1,
    total: 0
  },
  accommodatieDetail: null,
  werkorders: {
    results: [],
    totalPages: 0,
    currentPage: 1,
    total: 0
  },
  werkorderDetail: null,
  categories: [],
  existingAccommodaties: [],
  existingKampeerplaatsen: [],
  storingenDashboard: null
};

export default function facilityManagementReducer(state = initialState, action) {
  switch (action.type) {
    case FACILITY_STORINGEN_LOADING:
      return {
        ...state,
        storingen: {
          ...state.storingen,
          loading: true,
          error: null
        }
      };

    case FACILITY_STORINGEN_SUCCESS:
      return {
        ...state,
        storingen: {
          results: action.payload.storingen || [],
          totalPages: action.payload.totalPages || 0,
          currentPage: action.payload.currentPage || 1,
          total: action.payload.total || 0,
          loading: false,
          error: null
        }
      };

    case FACILITY_STORINGEN_ERROR:
      return {
        ...state,
        storingen: {
          ...state.storingen,
          loading: false,
          error: action.payload
        }
      };

    case FACILITY_STORING_DETAIL_SUCCESS:
      return {
        ...state,
        storingDetail: action.payload
      };

    case FACILITY_STORING_CREATE_SUCCESS:
      return {
        ...state,
        storingen: {
          ...state.storingen,
          results: [action.payload, ...state.storingen.results],
          total: state.storingen.total + 1
        },
        storingDetail: action.payload
      };

    case FACILITY_STORING_UPDATE_SUCCESS:
      return {
        ...state,
        storingen: {
          ...state.storingen,
          results: state.storingen.results.map(storing => 
            storing._id === action.payload._id ? action.payload : storing
          )
        },
        storingDetail: action.payload._id === state.storingDetail?._id ? action.payload : state.storingDetail
      };

    case FACILITY_ACCOMMODATIES_SUCCESS:
      return {
        ...state,
        accommodaties: {
          results: action.payload.accommodaties || [],
          totalPages: action.payload.totalPages || 0,
          currentPage: action.payload.currentPage || 1,
          total: action.payload.total || 0
        }
      };

    case FACILITY_ACCOMMODATIE_DETAIL_SUCCESS:
      return {
        ...state,
        accommodatieDetail: action.payload
      };

    case FACILITY_WERKORDERS_SUCCESS:
      return {
        ...state,
        werkorders: {
          results: action.payload.werkorders || [],
          totalPages: action.payload.totalPages || 0,
          currentPage: action.payload.currentPage || 1,
          total: action.payload.total || 0
        }
      };

    case FACILITY_WERKORDER_DETAIL_SUCCESS:
      return {
        ...state,
        werkorderDetail: action.payload
      };

    case FACILITY_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: action.payload
      };

    case FACILITY_DASHBOARD_SUCCESS:
      return {
        ...state,
        storingenDashboard: action.payload
      };

    case FACILITY_EXISTING_ACCOMMODATIES_SUCCESS:
      return {
        ...state,
        existingAccommodaties: action.payload
      };

    case FACILITY_EXISTING_KAMPEERPLAATSEN_SUCCESS:
      return {
        ...state,
        existingKampeerplaatsen: action.payload
      };

    default:
      return state;
  }
}